import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Image from 'react-bootstrap/Image';
import Dropdown from 'react-bootstrap/Dropdown';

import * as routes from 'routes';

import { LoggedUserContext } from 'contexts';

import pluto from './pluto.png';

const MainNavbar = () => {
  const { loggedUser } = useContext(LoggedUserContext);

  const {
    profile: { imageUrl }
  } = loggedUser;

  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand as={Link} to={routes.BASE_ROUTE}>
          <Image src={pluto} roundedCircle height={64} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link as={NavLink} to={routes.PRICING_ROUTE}>
              Pricing
            </Nav.Link>
            <Nav.Link as={NavLink} to={routes.COSTING_ROUTE}>
              Costing
            </Nav.Link>
            <Nav.Link as={NavLink} to={routes.TENDER_ROUTE}>
              Tender
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

        <Dropdown alignRight>
          <Dropdown.Toggle as="a">
            <Image src={imageUrl} roundedCircle width={32} />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={routes.LOGOUT_ROUTE} variant="danger">
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
